import clsx from 'clsx';
import { useMemo } from 'react';
import { PriceTypes, TPrice } from '~/shared/components/ProductCard/components/Price';
import { useUtils } from '~/shared/hooks/useUtils';
import { useFrame } from '~/shared/utils';
import { getSchemaPrice } from '~/shared/utils/schema-price';
import styles from './Multibuy.module.scss';
import { ProductPricesProps } from '../ProductPrices/ProductPrices';

type Props = ProductPricesProps & React.HTMLAttributes<HTMLDivElement>;

export const Multibuy: React.FC<Props> = ({ className, priceList, ...rest }) => {
    const { data: frame } = useFrame();
    const currency = frame.market.currency?.currency || 'DKK';

    const prices = useMemo(() => {
        if (priceList?.length) return <Prices prices={priceList} />;

        return null;
    }, [priceList]);

    return (
        <div className={clsx(styles.multibuyComponent, className)} {...rest}>
            <meta itemProp="priceCurrency" content={currency} />

            {prices}
        </div>
    );
};

interface PriceProps {
    label?: string;
    price: string | number | undefined;
    type: PriceTypes;
}

const MultibuyDisplay: React.FC<PriceProps> = ({ label, price, type }) => {
    const { convertPriceToLocale } = useUtils();

    return (
        <p className={clsx(styles.multibuy, styles[type])}>
            {label && <>{label} </>}

            <span className={styles.emphasized}>{convertPriceToLocale(price)}</span>
        </p>
    );
};

const Prices: React.FC<{ prices: TPrice[] }> = ({ prices }) => {
    const sortedPrices = useMemo(
        () => prices?.sort((a) => (a.type === PriceTypes.SALE ? -1 : 0)),
        [prices],
    );

    const schemaPrice = getSchemaPrice(prices);

    return (
        <>
            {schemaPrice && <meta itemProp="price" content={String(schemaPrice.value)} />}

            {sortedPrices?.map((price) => {
                const priceType = price.type || PriceTypes.DEFAULT;

                return (
                    <MultibuyDisplay
                        key={priceType}
                        type={priceType}
                        label={price.label}
                        price={price.value}
                    />
                );
            })}
        </>
    );
};
